
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class PendingOrdersGrid extends Serenity.EntityGrid<PendingOrdersRow, any> {
        protected getColumnsKey() { return PendingOrdersColumns.columnsKey; }
        protected getDialogType() { return PendingOrdersDialog; }
        protected getIdProperty() { return PendingOrdersRow.idProperty; }
        protected getInsertPermission() { return PendingOrdersRow.insertPermission; }
        protected getLocalTextPrefix() { return PendingOrdersRow.localTextPrefix; }
        protected getService() { return PendingOrdersService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;
        private FranchiseeId;
        private InvoiceId;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: PendingOrdersService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push({
                title: 'Assign to Enquiry',
                cssClass: 'edit-button',
                onClick: () => {
                    var SelectedKeys = this.rowSelection.getSelectedKeys();
                    if (SelectedKeys.length == 0) {
                        Q.alert("Please select atleast one Customer!");
                        return;
                    }
                    debugger;
                    new RioERP.Enquiry.PendingOrderEnquiryDialog(this, true, SelectedKeys).loadNewAndOpenDialog();
                },
                separator: true
            });

            return buttons;
        }
    }
}